import { ThemeOverride } from '@chakra-ui/react';

export const theme: ThemeOverride = {
  components: {
    Popover: {},
    Drawer: {
      sizes: { lg: { dialog: { maxW: '38rem' } } },
    },
  },
};
